import React, {Component} from 'react';
import axios from 'axios/index';
import {ListButton} from 'admin-on-rest';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import ReportJobBuilderForm from '../components/ReportJobBuilderForm';
import {RESOURCES as jobResources} from '../fuseReportsResourceMap';
import {isSysopOrSysadmin, hasSectionAccess} from '../shared/authFunctions';
import {getPostHeaders} from '../shared/serverFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import {ReportJobsConfig} from '../components/ReportJobsConfig';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import {Card, CardActions, CardText} from 'material-ui/Card';
import Icon from 'material-ui/svg-icons/action/work';
import NoAccess from '../noAccess';

export const fuseCreateReportJobIcon = Icon;

/**
 * Report Jobs form to assemble components to create a Report Job
 *
 */
export class ReportJobBuilder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            configData: null,
            selectedCategory: null,
            submitted: false,
            submitting: false,
            success: false
        };
    }

    handleConfig = (configData) => {
        this.setState({
            configData: configData
        });
    };

    handleFormSubmit = (data) => {
        this.setState({
            submitted: false,
            submitting: true
        }, () => {

            const tokenStatus = checkTokenStatus(null);
            if (tokenStatus.expired) {
                return;
            }

            const resource = jobResources.ReportJobs.CREATE(data);
            axios({
                method: resource.method,
                url: resource.uri,
                data: data,
                headers: getPostHeaders()
            }).then((result) => {
                if (result && result.data && result.data.payload) {
                    this.processSubmission(result);
                } else {
                    this.processSubmission(null);
                }
            }).catch((error) => {
                if (error.response) {
                    // Server response outside 2xx
                    console.log(error.response.data);
                    error = error.response.data;
                } else if (error.request) {
                    // No response
                    console.log(error.request);
                    error = error.request;
                } else {
                    console.log('Schedule Report Error', error.message);
                }
                this.processSubmission(null);
            });
        });
    };

    handleReset = () => {
        this.setState({
            submitted: false,
            submitting: false,
            success: false
        });
    };

    processSubmission = (data) => {
        let success = !!(data);
        this.setState({
            submitted: true,
            submitting: false,
            success: success
        }, () => {
            // If submission is successful, redirect to Jobs List
            setTimeout(() => {
                window.location.href = '/#/ReportJobs';
            }, 500);
        });
    };

    render() {
        const {
            configData,
            submitted,
            submitting,
            success
        } = this.state;

        if (!isSysopOrSysadmin()) {
            if (!hasSectionAccess('jobs')) return <NoAccess/>;
        }

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>Create A Report Job</span>;

        return (
            <div className="lists-container">
                <Card>
                    <CardActions style={viewStyles.actions}>
                        <ListButton basePath="/ReportJobs"/>
                    </CardActions>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <span className="list-description hide-print">
                            <p>
                                This system allows you to configure a Job to perform a given task. Choose one of the
                                Categories below then select a specific Report to configure.
                            </p>
                            <p>
                                Once configured and submitted, the system will run the Report.
                            </p>
                        </span>

                        <ReportJobsConfig onConfig={(e) => this.handleConfig(e)}/>

                        {configData &&
                            <ReportJobBuilderForm
                                configData={configData}
                                submitting={submitting}
                                submitted={submitted}
                                success={success}
                                onFormComplete={(e) => this.handleFormSubmit(e)}
                                onFormReset={this.handleReset}
                            />
                        }
                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/views/ReportJobBuilder.js